module.exports = __webpack_public_path__ + "static/4.72feb3e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/4.png
// module id = 826
// module chunks = 39236203315009 172526442442348